module.exports = __webpack_public_path__ + "img/圣诞帽.175487b2.png";